import React, { useContext, useEffect, useState } from 'react'

import { Button, Col, Form, Row, Skeleton, Typography } from 'antd'

import MarketingAudienceCard from '../audience/MarketingAudienceCard'
import { LOCAL_MERCHANT_CODE } from '../../../helpers/Globals'
import { apiGetAllAudiences } from '../../../helpers/Api'
import DiSkeletonCards from '../../DiSkeletonCards'
import MarketingEmpty from '../MarketingEmpty'

export default function MarketingOperationCreateSelectAudience({ contextValue, onChange, selectedAudience }) {

    const [refreshAudiences, setRefreshAudiences] = useState(0);
    const [audiences, setAudiences] = useState(null);
    const [loading, setLoading] = useState(true);

    const { errorNotification } = contextValue;
   
   /////////////////////////////////////////////////////////////////////////////////////////// 
               //////////////////// recupero i dati del pubblico ///////////////
   /////////////////////////////////////////////////////////////////////////////////////////// 
   
   useEffect(() => {
      
      const publicCode = sessionStorage.getItem(LOCAL_MERCHANT_CODE);
      
      if (!publicCode || publicCode === "") return;

      setLoading(true);

      try {
      (async () => {
         const res = await apiGetAllAudiences(publicCode);
   
         if (!res?.message) {
         setAudiences(res.data)
         setLoading(false)
         } else {
            setLoading(false)
            errorNotification(res.message)
         }
      })();
      } catch (error) {
      console.log(error)
      }

   },[refreshAudiences])
     
   /////////////////////////////////////////////////////////////////////////////////////////// 
               //////////////////// recupero i dati del pubblico ///////////////
   ///////////////////////////////////////////////////////////////////////////////////////////
   

  /////////////////////////////////////////////////////////////////////////////////////////// 
        // funzione per aggiornare il pubblico passata a tutti i componenti figli //
  ///////////////////////////////////////////////////////////////////////////////////////////
    const onSave = () => {
      setRefreshAudiences(refreshAudiences + 1)
    }
  /////////////////////////////////////////////////////////////////////////////////////////// 
        // funzione per aggiornare il pubblico passata a tutti i componenti figli //
  ///////////////////////////////////////////////////////////////////////////////////////////


   return (
     <div className='di-operation-wizard-wrapper'>
       <Form.Item
         name={"audienceCampaignIds"}
       >
          <Row gutter={[20, 20]}>
             {loading ?
                <>
                  <Skeleton.Input className='w-100 p-10 mb-10' active />
                  <DiSkeletonCards />
                </>
              :
                <>
                  {!audiences || audiences.length === 0 ? //condizione per mostrare o meno il pubblico
                      
                    //------------ aggiungi un pubblico quando non ne hai nessuno -----------
                     <div className='w-100'> <MarketingEmpty contextValue={contextValue} onSave={onSave} /></div>
                    //------------ aggiungi un pubblico quando non ne hai nessuno -----------
                  :
                    // ------- ciclo per mostrare il pubblico ----------
                      <>
                       {audiences.length > 0 && audiences.map((e) => {
                             return (
                              <Col key={e.id} span={8} xs={24} sm={12}  md={12} lg={8}>
                                 <MarketingAudienceCard
                                    contextValue={contextValue}
                                    selectedAudience={selectedAudience}
                                    description={e.description}
                                    amount={e.potentialUsers}
                                    onChange={onChange}
                                    onSave={onSave}
                                    title={e.title}
                                    id={e.id}
                                    hideEdit
                                />
                             </Col>
                             )
                          })
                       }
                    </>
                    // ------- ciclo per mostrare il pubblico ----------
                  }
                </>
            }
        </Row>
      </Form.Item>
     </div>
  )
}
